/** @format */

import { ProductStyle } from './product-style.interface';
import { ProductStylePrices } from './product-style-prices.interface';

export type BundleDataPrices = Omit<ProductStylePrices, 'mapPriceIndicator' | 'priceIndicator'>;

type fieldsToOmit =
  | 'colorAttributeBuckets'
  | 'definingAttributes'
  | 'descriptiveAttributes'
  | 'isEcodePreSale'
  | 'isPayPalEligible'
  | 'prices'
  | 'webActiveDate';

export interface BundleData extends Omit<ProductStyle, fieldsToOmit> {
  // Missing when all products in the bundle are out-of-stock
  prices?: BundleDataPrices;
}
